import { Http } from '@/lib/http';

export class UserService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/users';
  }

  create(user) {
    return this.httpClient().post(`${this.endpoint}`, user);
  }

  createUserPersonProfile(userId, person, canOverWrite) {
    return this.httpClient().post(`${this.endpoint}/${userId}/personProfile`, { canOverWrite, person});
  }

  enable(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/enable`);
  }

  disable(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/disable`);
  }

  findOne(id) {
    return this.httpClient().get(`${this.endpoint}/${id}`);
  }

  findAll(params) {
    const userId = localStorage.getItem('userId');
    localStorage.removeItem('userId');
    return this.httpClient().post(`${this.endpoint}/find`, {
      userId: userId,
      ...params,
      sort: params?.sort || 'id',
      order: params?.order || 'asc'
    });
  }

  fetchNonUsers({ skip, limit }) {
    return this.httpClient().post('onboarder/app/persons/non-users', { skip, limit })
  }

  update(id, user) {
    return this.httpClient().put(`${this.endpoint}/${id}`, user);
  }

  resetPassword(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/password-reset`);
  }

  updatePassword({ id }) {
    return this.httpClient().patch(`${this.endpoint}/${id}/update-password`);
  }
  
  newPassword(data) {
    return this.httpClient().patch(
      `${this.endpoint}/${data.id}/new-password`,
      data
    );
  }
  
  findSignature(id) {
    return this.httpClient().get(`${this.endpoint}/signature/${id}`);
  }

  uploadSignature(data, id) {
    return this.httpClient().patch(`${this.endpoint}/signature/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  deleteSignature(id) {
    return this.httpClient().delete(`${this.endpoint}/signature/${id}`);
  }
  
  uploadAvatar(data, id) {
    return this.httpClient().patch(`${this.endpoint}/avatar/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  deleteAvatar(id) {
    return this.httpClient().delete(`${this.endpoint}/avatar/${id}`);
  }

  findAvatar(id) {
    return this.httpClient().get(`${this.endpoint}/avatar/${id}`);
  }

  resetToken(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/reset-token`);
  }

  delete(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

  batchUpload(data) {
    return this.httpClient().post(`${this.endpoint}/batch-upload`, data);
  }

  unlinkPerson(userId) {
    return this.httpClient().patch(`${this.endpoint}/${userId}/unlink-person`);
  }

  linkExistingPerson(userId, personId) {
    return this.httpClient().patch(`${this.endpoint}/${userId}/link-person`, { personId });
  }

  fetchAllStaffNonUsers() {
    return this.httpClient().post(`onboarder/app/persons/non-users`, {
      skip: 0,
      limit: 500,
      sort: { firstName: 'asc' }
    });
  }

  searchPersons(query) {
    return this.httpClient().post(`onboarder/app/persons/non-users`, {
      searchParam: query,
      skip: 0,
      limit: 20,
      sort: {}
    });
  }

  searchStaffPersonsByEmail(email) {
    return this.httpClient().post(`onboarder/app/persons/find`, {
      searchParam: email,
      memberCategory: 'Staff',
      page: 1,
      limit: 20
    });
  }

  reset2FA(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/reset-two-factor`);
  }
}